import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Studio", href: "/#studio" },
  { label: "Creators", href: "/#creators" },
  { label: "Work", href: "/#work" },
  { label: "Orders", href: "/#orders" },
  { label: "Manifesto", href: "/#manifesto" },
  { label: "Campaign", href: "/#campaign" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? "bg-black/60 backdrop-blur-2xl border-b border-white/10" : "border-b border-transparent"}`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src="/etoire-logo-red.png" alt="Etoire" className="h-10 md:h-12 w-auto object-contain" />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground hover:text-volt transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="nav-admin-btn"
            onClick={() => navigate("/login")}
            className="font-mono text-xs tracking-[0.2em] uppercase border border-white/20 hover:border-volt hover:text-volt px-4 py-2 transition-colors duration-200"
          >
            Admin
          </button>
        </nav>

        <button className="md:hidden" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}>
          {open ? <X className="text-volt" /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-black/90 backdrop-blur-2xl border-b border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="font-mono text-sm tracking-[0.2em] uppercase text-muted-foreground">
                  {l.label}
                </a>
              ))}
              <button onClick={() => navigate("/login")} className="font-mono text-sm tracking-[0.2em] uppercase text-volt text-left">
                Admin
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
